import * as React from 'react';
import _ from 'lodash';
import clsx from 'clsx';

import { ifClickable } from '../../utils/touchUtils';

interface Props {
  'aria-label'?: string;
  children?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
  hidden?: boolean;
  onFocus?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  role?: React.AriaRole;
}

export default class InputContainer extends React.PureComponent<Props> {
  render() {
    const {
      'aria-label': ariaLabel,
      children,
      className: classNameFromProps,
      disabled,
      hidden,
      onClick,
      onFocus,
      role,
    } = this.props;

    const className = clsx('InputContainer', classNameFromProps, {
      'is-disabled': disabled,
      'is-hidden': hidden,
    });

    const clickHandler = !disabled ? ifClickable(onClick) : _.noop;
    // TODO

    return (
      <div
        aria-label={ariaLabel}
        className={className}
        data-testid={this.props['data-testid']}
        onFocus={onFocus}
        onClick={clickHandler}
        role={role}
      >
        {children}
      </div>
    );
  }
}
